<div class="container">
    <div *ngIf="loadMenus" id="loadingPage"></div>
    <div *ngIf="!loadMenus">
        <div  *ngFor="let menu of menus;let i=index">
            <menu-card  (OnAdd)="OpenMenuModal(i)" [menu]="menu"></menu-card>
        </div>
    </div>
</div>
